import ApiService from "@/utils/api.service";

export default {

    list(context) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("order")
                .then(({ data }) => {
                    context.commit("setList", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    update(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("order/" + params.id, { status: params.status }).
                then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        })
    },
    get(context, orderId) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("order/" + orderId)
                .then(({ data }) => {
                    context.commit("setOrder", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    getImages(context, orderId){
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("order/" + orderId + "/images")
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    getJob(context, orderId) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("order/" + orderId + "/job")
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    confirm(context, orderId) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("order/" + orderId + "/confirm")
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    upload(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("order/" + params.orderId + "/upload", { files: params.files })
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    changeImage(context, params){
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("order/" + params.orderId + "/change-image", { orignalId: params.originalId, newId: params.newImageId })
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    }

}